// Timer component - shows how long you've been "talking"
// You can customize the start date to your actual relationship start date

// Set your relationship start date here (YYYY, MM-1, DD, HH, MM, SS)
// Note: Month is 0-indexed (January = 0, February = 1, etc.)
const RELATIONSHIP_START = new Date(2025, 11, 8, 0, 0, 0) // December 8, 2025

let timerInterval: number | null = null

export function initTimer(): void {
  const timerElement = document.getElementById('timer')
  if (!timerElement) return

  // Update immediately
  updateTimer(timerElement)

  // Update every second
  timerInterval = window.setInterval(() => {
    updateTimer(timerElement)
  }, 1000)
}

function updateTimer(element: HTMLElement): void {
  const now = new Date()
  const diff = now.getTime() - RELATIONSHIP_START.getTime()

  // Calculate time components
  const seconds = Math.floor(diff / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)
  const months = Math.floor(days / 30.44) // Average days per month

  // Format: 01M-02D-21H-01S
  const displayMonths = String(months).padStart(2, '0')
  const displayDays = String(days % 30).padStart(2, '0')
  const displayHours = String(hours % 24).padStart(2, '0')
  const displayMinutes = String(minutes % 60).padStart(2, '0')

  element.textContent = `${displayMonths}M-${displayDays}D-${displayHours}H-${displayMinutes}M`
}

export function stopTimer(): void {
  if (timerInterval) {
    clearInterval(timerInterval)
    timerInterval = null
  }
}

export function setStartDate(date: Date): void {
  // Allow dynamic updating of the start date
  Object.assign(RELATIONSHIP_START, date)
}
